// Angular
import { IGetEventsDetailsResponse, IToteResultResponse } from '@amwager/util-ts';
import { WagerFacade } from '@amwager/wager/data-access';
import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  ViewChild,
  // OnDestroy,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Inject
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  SafeUrl,
  DomSanitizer
} from '@angular/platform-browser';
import { Router } from '@angular/router';

// Local library
import {
  DateFormatPipe,
  SanitizerPipe,
TranslatePipe
} from '@amwager/util';

//Third party
import videojs from 'video.js';
import Hls from 'hls.js';
import { Subscription } from 'rxjs';
import { Dictionary } from '@ngrx/entity';
import _ from 'lodash';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { LiveVideoComponent } from '../live-video/live-video.component';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'feature-mat-replay-video',
  templateUrl: './replay-video.component.html',
  styleUrls: ['./replay-video.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    SanitizerPipe,
    CdkDrag,
    DateFormatPipe,
    TranslatePipe
  ],
  standalone: true
})

export class ReplayVideoComponent implements OnInit, OnDestroy, AfterViewInit {

  private getSelectedReplayInfoSubs!: Subscription;
  isReplayInfoSuccess: boolean = false;
  name: string | undefined;
  videoUrl?: string;
  private video!: any;
  private hls!: any;
  safeUrl!: SafeUrl;
  runners: any[] = [];
  resultRunId!: any;
  resultRunners!: any;
  resultMorningMatrixs!: any;

  track: string = '';
  date: string = '';
  breed: string = '';
  race: number = 0;
  runId: string = '';
  eventId: string = '';
  poolId: string = '';
  showOdds: boolean = false;

  poolMatrix!: any;
  events!: any;

  @ViewChild('videoPlayer', {static: true}) videoPlayer!: ElementRef<HTMLVideoElement>;

  liveVideoUrl: string = '';

  constructor(
    private wagerFacade: WagerFacade,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private dialogRef: MatDialogRef<LiveVideoComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.liveVideoUrl = data;
  }

  /**
   * On init
   * @returns {void}
   */
  ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.wagerFacade.getSelectedReplayInfo$().subscribe((res?: any) => {
      if (res !== undefined) {
        this.track = res.track;
        this.date = res.date;
        this.breed = res.breed;
        this.race = res.race;
        this.runId = res.runId;
        this.eventId = res.eventId;
        this.poolId = res.poolId;
        this.showOdds = res.showOdds;

        this.isReplayInfoSuccess = true;
      }

      if (this.getSelectedReplayInfoSubs && this.isReplayInfoSuccess)
        this.getSelectedReplayInfoSubs.unsubscribe();
    });

    this.wagerFacade.getSelectEventTrackRaceEntities$()
      .subscribe((allEventTrackRace: Dictionary<IGetEventsDetailsResponse>) => {
        if (_.isEmpty(allEventTrackRace)) return;

        this.events = allEventTrackRace;
      });

    this.wagerFacade.getRaceMatrixReplay$()
      .subscribe((callback) => {

        if (callback === undefined) return;
        this.poolMatrix = callback;

        // if (this.poolMatrix[this.poolId] !== undefined) {
          // if (this.resultRunId === this.poolMatrix[this.poolId].response.ToteResponse.RunId)
            this.runners = this.calculateRunnerOdds(this.resultRunners, this.resultMorningMatrixs);
        // }
      });

  }

  /**
   * After view init
   * @returns {void}
   */
  ngAfterViewInit() {
    const videoElement = this.videoPlayer.nativeElement;

    let i = 0;
    this.wagerFacade.getRaceResult$()
    .subscribe((results?: IToteResultResponse) => {
      this.videoUrl = undefined;

      if (!results || !results?.replayVideo || i > 0) return;

      const replayVideo = results?.replayVideo.replace(/^http:/, 'https:');

      this.cleanupVideoPlayer();

      this.video = videojs(videoElement || '', {
      }, function onPlayerReady() {
      });

      if (Hls.isSupported()) {
        // const hls = new Hls();
        this.hls = new Hls();
        this.hls.loadSource(replayVideo);
        this.hls.attachMedia(videoElement);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoElement.play();
        });

        setTimeout(() => {

          // only execute getPoolMatrix() if there's data on race, eventId, and poolId
          if (this.race && this.eventId && this.poolId) {
            // TODO: JIM, what's the purpose of this function? What function/feature is using this?
            this.wagerFacade.getPoolMatrix(
              'RaceComponent:toBuildMatrixTables',
              {
                raceId: this.race,
                eventId: this.eventId,
                runId: _.values(results?.morningMatrixs)[0]?.RunId,
                poolId: this.poolId,
                replay: true
              }
            );
          }

          this.resultRunId =_.values(results?.morningMatrixs)[0]?.RunId;
          this.resultRunners = results?.runners;
          this.resultMorningMatrixs = results?.morningMatrixs;

          // this.runners = this.calculateRunnerOdds(results?.runners, results?.morningMatrixs);
        }, 0);

        // if (this.poolIds.includes(this.poolId)) {
          // this.runners = this.calculateRunnerOdds(results?.runners, results?.morningMatrixs);
        // }
      }

      i++;
    });
  }

  /**
   * On destroy
   * @returns {void}
   */
  ngOnDestroy() {
    this.cleanupVideoPlayer();
  }

  /**
   * Calculate runner odds
   * @param {any} runners - Runners
   * @param {any} morningMatrixs - Morning matrixs
   * @returns {any} - Runners
   */
  calculateRunnerOdds(runners: any, morningMatrixs: any): any {

    // this.poolMatrix[this.poolId]
    // this.poolMatrix[this.poolId].response.ToteResponse.RunId
    if (
      runners &&
      morningMatrixs &&
      this.poolMatrix !== undefined &&
      this.resultRunId === this.poolMatrix?.response?.ToteResponse?.RunId
    ) {
      let c;
      let r;
      const matrixOdds = this.poolMatrix?.response?.ToteResponse;
      const morningMatrix = _.values(morningMatrixs)[0];
      for (c = 0; c < morningMatrix?.Rows[0].Columns.length; c++) {
        for(r = 0; r < runners.length; r++)
        {
          if(runners[r].Id == c + 1) {
            runners[r].ML = morningMatrix?.Rows[0].Columns[c].Formatted;
          }
        }
      }

      for (c = 0; c < matrixOdds?.Rows[0].Columns.length; c++) {
        for(r = 0; r < runners.length; r++)
        {
          if(runners[r].Id == c + 1) {
            runners[r].Odds = matrixOdds?.Rows[0].Columns[c].Formatted;
          }
        }
      }

    }

    return runners;
  }

  /**
   * View Result — jump to the Results page with this event/race
   * pre-selected. Pushes routing state that `ResultsComponent`
   * consumes via `pendingInitialSelection` to land on the exact
   * race the user was watching.
   * @returns {void}
   */
  showLatestFinishedEvent(): void {
    const event = this.events ? _.get(this.events, this.eventId) : undefined;

    if (event) {
      this.wagerFacade.setLatestFinishedEvent(event, this.race);
    }

    this.dialogRef.close();

    // Forward the replay's date so Results lands on the same day.
    // Prefer a resolved event id over the raw hint (which may be a trackId).
    this.router.navigate(['/results'], {
      state: {
        eventId: event?.id || this.eventId,
        runId: this.runId || event?.ToteResponse?.RunId,
        raceId: this.race,
        date: this.date
      }
    });
  }

  /**
   * Close dialog
   * @returns {void}
   */
  closeDialog(): void {
    this.dialogRef.close();
  }

  /**
   * Cleanup video player
   * @returns {void}
   */
  private cleanupVideoPlayer(): void {
    // if (this.hls) {
    //   this.hls.destroy();
    // }

    if (this.video) {
      this.video.pause();
      this.video.dispose();
    }
  }

}
